export const ICONS = [
  'menu-advertiser',
  'plus-circle',
  'menu-affilate',
  'android',
  'other-apple',
  'shopping-bag-02',
  'bin',
  'buttons-book',
  'other-box',
  'buttons-load',
  'buttons-pencil',
  'other-metrics',
  'buttons-chat',
  'check',
  'click-tracking',
  'controls-close',
  'stop-square',
  'controls-crown',
  'reporting-conversion',
  'buttons-copy-big',
  'other-danger',
  'other-date',
  'edit-03',
  'other-menu',
  'buttons-email',
  'reporting-event',
  'menu-external',
  'controls-filters',
  'menu-finance',
  'menu-folders',
  'menu-home',
  'menu-landings',
  'reporting-lead',
  'link-03',
  'exit',
  'menu-managment',
  'menu-communications',
  'menu-notification',
  'settings',
];
